import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { setBreadcrumbs, setBreadcrumbsCurrentElement } from 'store/breadcrumbsSlice';
import { ElementType, ElementViewerCrumbsData, ElementViewerCrumbsDataItem } from 'components/element-viewer/index';
import { setPageTitle } from 'store/pageTitleSlice';
import { useLocation } from 'react-router-dom';

export default function usePageTitleCrumbs(elementInfo: ElementType, crumbsData: ElementViewerCrumbsData) {
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        let match = location.pathname.match(/\/(favorite|folder)\/([0-9]+)/);

        const referrerType = match && match[1] && match[2] ? match[1] : undefined;

        let crumbsType: any = undefined;

        switch (referrerType) {
            case 'favorite':
                if (crumbsData?.favorite?.length > 0) {
                    crumbsType = 'favorite';
                }
                break;
            case 'folder':
                if (crumbsData?.folderCurrent?.length > 0) {
                    crumbsType = 'folderCurrent';
                }
                break;
        }

        if (!crumbsType) {
            if (crumbsData?.folderDefault?.length > 0) {
                crumbsType = 'folderDefault';
            } else {
                crumbsType = 'category';
            }
        }

        dispatch(
            setBreadcrumbs(
                ((crumbsData as any)?.[crumbsType] ?? []).map((crumbsItem: ElementViewerCrumbsDataItem) => ({
                    ...crumbsItem,
                    translate: false,
                })),
            ),
        );
        dispatch(setBreadcrumbsCurrentElement(elementInfo?.row.name)); //workaround for recent items command menu
        dispatch(setPageTitle(elementInfo?.row.name));
    }, [elementInfo.row?.elementId, elementInfo.row?.segmentValueId]);
}
